import { TRequestResetPasswordFormValues } from './RequestResetPassword.types';

export const REQUEST_RESET_PASSWORD_FORM_DEFAULT_VALUES: TRequestResetPasswordFormValues =
  {
    email: '',
  };
